import { GATE_FILTER_ID } from '../filters/forTempQueryResult';

/**
 * Drop the #332 display gate from a view: clear the accumulated result ids, rewind the server
 * paging that produced them, and remove the filter itself from the loki pipeline.
 *
 * The paging rewind is not incidental. Consumers read "this view has fetched a page
 * (`page >= 1`) but holds no gate ids" as "the server returned nothing for the current filter" —
 * see `serverReturnedNoResults` in willExport_item_item-patch. Clearing the ids while leaving
 * `page` advanced fabricates exactly that state, so a grid full of rows reports nothing to
 * export. Ids and paging have to move together.
 *
 * Deliberately does NOT arm `awaitingFirstServerPage`: this lifts a gate, it does not begin a
 * new gated fetch. Arming it here would re-enter the stage-2 fetch that #1712 latches on that
 * same flag.
 *
 * Shared by both dbViews variants (index.js and index.datasync.js) so the two cannot drift, and
 * used by each one's `resetPagingAndGate`, which is this plus a fresh queryId and the latch.
 *
 * @param {object} dbView
 * @param {object} viewCriteria
 */
export default function liftGate(dbView, viewCriteria) {
    dbView.page = 0;
    dbView.serverSideOffset = 0;
    dbView.gateResultIds = [];
    viewCriteria.removeFilters(GATE_FILTER_ID);
}
